import { Platform, StyleSheet } from "react-native";
import { colors, sizes } from "asset/constant";
import { mq, sn } from "utils";

const styles = StyleSheet.create({
  rRowContainerCenterAlign: {
    flexDirection: "row-reverse",
    alignItems: "center",
    flex: 1,
  },

  containerW: { width: "93%" },
  paddingH: { paddingHorizontal: sizes.space },
  marginH: { marginHorizontal: "3.5%" },

  fitWidth: { width: "100%" },
  fitHeight: { height: "100%" },
  fitContent: { width: "100%", height: "100%" },

  screenBg: { backgroundColor: colors.bg.screen },

  container: { flex: 1 },
  growContainer: { flexGrow: 1 },

  fix: { position: "absolute" },
  fixFitContent: { position: "absolute", width: "100%", height: "100%" },

  wrap: { flexWrap: "wrap" },
  row: { flexDirection: "row" },
  rowCenterAlign: { flexDirection: "row", alignItems: "center" },
  rowCenterElements: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  rowContainerCenterElements: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  rowWrap: { flexDirection: "row", flexWrap: "wrap" },
  rRowWrap: { flexDirection: "row-reverse", flexWrap: "wrap" },

  justifySpaceEvenly: { justifyContent: "space-evenly" },

  rRowCenterAlignSpaceBetween: {
    flexDirection: "row-reverse",
    alignItems: "center",
  },

  responsiveBoxContainer: {
    width: sn("100%", "100%", "50%", "50%"),
    marginBottom: sizes.space,
  },

  rRow: { flexDirection: "row-reverse" },
  rRowCenterAlign: { flexDirection: "row-reverse", alignItems: "center" },
  rRowCenterElements: {
    flexDirection: "row-reverse",
    alignItems: "center",
    justifyContent: "center",
  },
  rRowContainerCenterElements: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row-reverse",
    paddingHorizontal: sizes.space / 2,
  },

  selfEnd: { alignSelf: "flex-end" },
  selfCenter: { alignSelf: "center" },
  selfStart: { alignSelf: "flex-start" },
  alignFEnd: { alignItems: "flex-end" },
  alignCenter: { alignItems: "center" },
  alignFStart: { alignItems: "flex-start" },
  justifyFEnd: { justifyContent: "flex-end" },
  justifyCenter: { justifyContent: "center" },
  justifyFStart: { justifyContent: "flex-start" },
  justifySEvenly: { justifyContent: "space-evenly" },
  justifySAround: { justifyContent: "space-around" },
  justifySBetween: { justifyContent: "space-between" },

  textAlignL: { textAlign: "left" },
  textAlignR: { textAlign: "right" },
  textAlignC: { textAlign: "center" },

  centralElements: { alignItems: "center", justifyContent: "center" },
  centralElContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },

  overFlowH: { overflow: "hidden" },

  removeGaps: {
    padding: 0,
    paddingRight: 0,
    paddingLeft: 0,
    paddingTop: 0,
    paddingBottom: 0,
    paddingVertical: 0,
    paddingHorizontal: 0,
    margin: 0,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    marginVertical: 0,
    marginHorizontal: 0,
  },

  textLineThrough: { textDecorationLine: "line-through" },
  textUnderline: { textDecorationLine: "underline" },

  b: {
    borderTopWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderTopColor: "",
    borderRightColor: "",
    borderBottomColor: "",
    borderLeftColor: "",
  },
});

export const css = {
  ...styles,
  size: (w: number, h: number) => ({ width: mq(w), height: mq(h) }),
  square: (size: number) => ({ width: mq(size), height: mq(size) }),
  circle: (size: number) => ({
    width: mq(size),
    height: mq(size),
    borderRadius: mq(size),
  }),
  width: (w: number) => ({ width: mq(w) }),
  height: (h: number) => ({ height: mq(h) }),
  inWidth: (mw: number) => ({ inWidth: mq(mw) }),
  minHeight: (mh: number) => ({ minHeight: mq(mh) }),
  perWidth: (percent = 100) => ({ width: percent + "%" }),
  perHeight: (percent = 100) => ({ height: percent + "%" }),
  ratio: (aspectRatio: number) => ({ aspectRatio }),
  radius: (borderRadius: number) => ({ borderRadius }),
  radiuses: (tl?: number, tr?: number, br?: number, bl?: number) => ({
    borderTopLeftRadius: tl,
    borderTopRightRadius: tr,
    borderBottomLeftRadius: bl,
    borderBottomRightRadius: br,
  }),
  zIndex: (zIndex: number) => ({ zIndex }),
  bgColor: (backgroundColor: string) => ({ backgroundColor }),
  shadow: (value?: number, color?: string) => ({
    ...(Platform.OS !== "ios" ? { elevation: value } : {}),
    shadowColor: color || colors.black,
  }),
  shadowForWeb: (val: number) => {
    return {
      shadowColor: "#000000",
      shadowOffset: {
        width: 0,
        height: 0,
      },
      shadowOpacity: (val - 1) * 0.02 + 0.18,
      shadowRadius: val === 1 ? 1 : val * 0.7,
      elevation: val,
    };
  },
  border: (width?: number, color?: string) => ({
    borderWidth: width || 1,
    borderColor: color || colors.text.normal,
  }),
  borders: (
    t?: number,
    r?: number,
    b?: number,
    l?: number,
    tc?: string,
    rc?: string,
    bc?: string,
    lc?: string
  ) => ({
    borderTopWidth: t || 1,
    borderRightWidth: r || 1,
    borderBottomWidth: b || 1,
    borderLeftWidth: l || 1,
    borderTopColor: tc,
    borderRightColor: rc || tc,
    borderBottomColor: bc || tc,
    borderLeftColor: lc || tc,
  }),
  margin: (margin: number) => ({ margin: mq(margin) }),
  marginX: (x: number) => ({ marginHorizontal: x }),
  marginY: (y: number) => ({ marginVertical: y }),
  margins: (top?: number, right?: number, bottom?: number, left?: number) => ({
    marginTop: top && mq(top),
    marginRight: right && mq(right),
    marginBottom: bottom && mq(bottom),
    marginLeft: left && mq(left),
  }),
  padding: (padding: number) => ({ padding }),
  paddingX: (x: number) => ({ paddingHorizontal: x }),
  paddingY: (y: number) => ({ paddingVertical: y }),
  paddings: (top?: number, right?: number, bottom?: number, left?: number) => ({
    paddingTop: top,
    paddingRight: right,
    paddingBottom: bottom,
    paddingLeft: left,
  }),

  dropShadow: (
    x = 0,
    y = 0,
    shadowOpacity = 0.5,
    shadowRadius = 5,
    shadowColor = "#dddddd"
  ) => ({
    shadowOffset: { width: x, height: y },
    shadowOpacity,
    shadowRadius,
    shadowColor,
  }),
};
